const insertVarInTxt = ({
  input,
  value,
  key,
  onChange,
  onAfterChange,
}) => {
  if (!input) return;

  const start = input.selectionStart ?? value.length;
  const end = input.selectionEnd ?? value.length;

  const variable = `{{${key}}}`;

  const newValue =
    value.substring(0, start) +
    variable +
    value.substring(end);

  onChange(newValue);

  setTimeout(() => {
		input.focus();
		input.selectionStart =
			input.selectionEnd =
				start + variable.length;

		onAfterChange?.(newValue);
	}, 0);
};

export default insertVarInTxt;